import { useState } from 'react'
import './App.css'
import Popup from './Popup';

function App() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [modal, setModal] = useState(false);

  const handleJoin = (e) => {
    e.preventDefault();
    if ((name.match(/\s+/g) || email.match(/\s+/g) || !email.endsWith('.com')) && name.length > 2) {
      alert("Please enter valid information")
    } else {
      console.log('called')
      fetch('https://api.baserow.io/api/database/rows/table/142232/?user_field_names=true', {
        method: 'POST',
        headers: {
          Authorization: 'Token rCNGBV38Ue009XrzUH5Jb6DUnzxEPIsp',
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "Name": name,
          "Email": email
        })
      }).then(res => res.status === 200 ? (() => {
        setModal(true)
        setEmail('')
        setName('')
      })() : alert("Error"))
    }
  }

  const closeModal = () => {
    setModal(false);
  };

  return (
    <div className="min-h-screen bg-slate-900   flex flex-col justify-between gap-10" >
      {modal && <Popup onClose={closeModal} />}
      <div className="bg-gradient-to-t from-slate-900 to-black">
        <div className="mx-auto container text-white flex flex-col items-center justify-between">


          <div className="flex justify-center w-full -mt-16">
            <img src="Images/gymlog_dark2-removebg-preview.png" className="w-[320px]" style={{ mixBlendMode: 'hard-light' }} alt="logo" />
          </div>
          <h1 className="text-[36px] text-center font-inter font-light">Transform Your Fitness Journey with <span className="text-blue-400">GymLog</span>: <br />The Ultimate Workout Tracking Tool </h1>
          <form className="flex flex-col gap-5 mt-20" onSubmit={handleJoin}>
            <input type="text" className="bg-slate-900 p-3 rounded-md sm:w-[480px]" placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} required />
            <input type="email" className="bg-slate-900 p-3 rounded-md sm:w-[480px]" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <button type="submit" className={` rounded-md p-3  ${(email === "" || name === "") ? 'bg-gray-800 text-gray-500' : 'bg-gray-700 hover:bg-gray-900'}`} >Join</button>
          </form>
        </div>
        <h2 className="text-2xl text-white font-semibold font-inter text-center mt-14">STAY CONSISTENT <br /> <span className="text-blue-400">GymLogMe</span> makes it easy!</h2>
      </div>
      <div className="flex flex-col gap-4">
        <div className="gap-6 px-2 py-8 container mx-auto flex flex-col md:flex-row text-white  items-center">

          <img src="Images/product1.png" className="w-full  md:w-2/4 lg:w-2/3 product_img " alt="product" />
          <h2 className="text-xl text-center">Maximize Your Results: Stay Accountable and Consistent with GymLogMe, Your Fitness Journey Partner</h2>
        </div>
        <div className="gap-6 px-2 py-8 container mx-auto flex flex-col-reverse md:flex-row text-white items-center">

          <h2 className="text-xl text-center">Available in Mobile version as well, Manage your workouts in few clicks. Unleash Your Potential: Crush Your Fitness Goals with GymLog, the Ultimate Workout Consistency Companion</h2>
          <img src="Images/product_mobile.jpeg" className="w-2/3  md:w-1/4  " alt="product" />
        </div>
      </div>
      <div className="text-white w-full text-center pt-10 pb-5">
        Made by Nimish with <span className="text-red-800">❤</span>
        <a href="https://twitter.com/BandhaNimish" target="_blank" rel="noreferrer" className="text-blue-400 px-2">Twitter</a>
      </div>
    </div>
  );
}

export default App;
